import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import useAuthStore from "../../store/authStore";
import SCSpinner from "../loaders/SCSpinner";

export default function AdminGuard({ children }) {
  const status = useAuthStore((s) => s.status);
  const user = useAuthStore((s) => s.user);
  const checkAuth = useAuthStore((s) => s.checkAuth);

  useEffect(() => {
    if (status === "idle") checkAuth();
  }, [status, checkAuth]);

  if (status === "idle" || status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-canvas">
        <SCSpinner size={56} />
      </div>
    );
  }

  // Customer and admin sessions share the same cookie/session mechanism
  // now that real customer accounts exist — "authenticated" alone no
  // longer implies "admin," so a signed-in customer must be turned away
  // here too, not just left to the backend's requireAdmin 403s.
  if (status === "unauthenticated" || user?.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
